const generateRandom16 = (): string =>
  ('00000000000000000' + (Math.random() * 0xffffffffffffffff).toString(16)).slice(-16)

export const uuidish = (): string => {
  const a = generateRandom16()
  const b = generateRandom16()
  return (
    a.slice(0, 8) +
    '-' +
    a.slice(8, 12) +
    '-4' +
    a.slice(13) +
    '-a' +
    b.slice(1, 4) +
    '-' +
    b.slice(4)
  )
}
